module.exports = __webpack_public_path__ + "static/media/sia-equ-div-incl.17bb48b1.png";